import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  activeRoomId: null,
  activeStore: null, // To start a new chat with a store
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    toggleChat: (state) => {
      state.isOpen = !state.isOpen;
      // Don't reset active room/store when toggling so they can minimize and restore
    },
    openChatWithStore: (state, action) => {
      state.isOpen = true;
      state.activeStore = action.payload; // { id, name, ... }
      state.activeRoomId = null; // Clear room id because we are starting fresh with a store
    },
    openChatRoom: (state, action) => {
      state.isOpen = true;
      state.activeRoomId = action.payload; // roomId
      state.activeStore = null; 
    },
    closeChat: (state) => {
      state.isOpen = false;
    },
    goBackToRoomList: (state) => {
      state.activeRoomId = null;
      state.activeStore = null;
    }
  },
});

export const { toggleChat, openChatWithStore, openChatRoom, closeChat, goBackToRoomList } = chatSlice.actions;
export default chatSlice.reducer;
